<template>
  <div class="pa-2">
    <v-card>
      <v-card-text :style="{ height: contentHeight + 'px' }">
        <a-table-f-api
          ref="table"
          :api="getUrl"
          :model="model"
          :useQuery="true"
          :defaults="getConfigView(viewName).index.defaults"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import genModel from "@/share/components/libs/genModel";
import table from "./table";

export default {
  mixins: [table, genModel],
  data() {
    return {
      showForm: false,
      editedId: 0,
    };
  },
  computed: {
    getUrl() {
      return this.$root.api[this.$route.params.api];
    },
    model() {
      this.$root.title = this.getConfigView(this.viewName).name;
      return this.modelIndex;
    },
  },
};
</script>